import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';

import Card, { CardItem } from './Card';
import AMD from '../../../common/amd/AMD';

import { allStatesMap } from '../../../helpers/states';
import { getFormatedDate } from "../../../helpers/parsers";
import { STATES } from "../../../helpers/constants";

const ApplicationDetails = ({ application, state }) => {
    const {
        code,
        created,
        lastModifiedUser,
        cooperationName,
        landerName,
        loan,
        moneyTransferInformation
    } = application;

    return (
        <Card title={'Դիմումի մանրամասներ'} notification={state === STATES.requestFailed}>
            <Row type='flex' justify='start'>
                <Col span={6}>
                    <CardItem name='Դիմումի համար' value={code || '-'}/>
                </Col>
                <Col span={6}>
                    <CardItem name='Կարգավիճակ' value={allStatesMap.get(state) || '-'} />
                </Col>
                <Col span={6}>
                    <CardItem name='Ստեղծման ամսաթիվ' value={getFormatedDate(created) || '-'} />
                </Col>
                <Col span={6}>
                    <CardItem name='Սպասարկող' value={lastModifiedUser || '-'} />
                </Col>
            </Row>
            <Row type='flex' justify='start'>
                <Col span={6}><CardItem name='Համագործակցություն' value={cooperationName || '-'}/></Col>
                <Col span={6}><CardItem name='Բանկ' value={landerName || '-'}/></Col>
                <Col span={6}><CardItem name='Վարկի գումար' value={loan ? <AMD value={loan.amount}/> : '-'}/></Col>
                {state === STATES.finished && (
                    <Col span={6}>
                        <CardItem
                            name='Փոխանցված գումար'
                            value={moneyTransferInformation ?
                                <div>
                                    <AMD value={moneyTransferInformation.transferredAmount}/>
                                    <div style={{ display: 'flex', fontSize: '14px', color: '#636970' }}>
                                        <AMD value={moneyTransferInformation.commission}/>&nbsp;միջնորդավճար
                                    </div>
                                </div>
                            : '-'}
                        />
                    </Col>
                )}
            </Row>
        </Card>
    )
};

ApplicationDetails.propTypes = {
    application: PropTypes.object.isRequired,
};

export default ApplicationDetails;